import { useState } from "react";
import fileService from "../services/fileService";
import { ItemImage, ItemImageFile } from "../models/ItemModel";

export type ImageUploadResult = { clientFileName: string,  uploadResult: string };
export type UploadResult = ItemImage & ImageUploadResult;

export const useImageUpload = () => {
    const [images, setImages] = useState<(ItemImageFile | ItemImage)[]>([]);
    const [imagesToDelete, setImagesToDelete] = useState<{ itemId: number, imageName: string }[]>([]);
    const [uploadProgress, setUploadProgress] = useState<number>(0);

    const uploadItemImages = async (itemId: number, filesToUpload: File[]) => {
        if (filesToUpload && filesToUpload.length > 0) {
            const uploadResults: UploadResult[] = await fileService.uploadItemImage(itemId, filesToUpload,
                (event: ProgressEvent) => {
                    const percentCompleted = Math.round((event.loaded * 100) / event.total);
                    setUploadProgress(percentCompleted);
                }
            );

            return uploadResults;

        }
    }

    const deleteItemImages = async (imageToDelete: { itemId: number, imageName: string }[]) => {
        if(imageToDelete && imageToDelete.length > 0) {
            imageToDelete.forEach(async (image) => {
                await fileService.deleteItemImage(image.itemId, image.imageName);
            });
        }
    }

    return {
        images,
        setImages,
        imagesToDelete,
        setImagesToDelete,
        uploadItemImages,
        deleteItemImages,
        uploadProgress,
        setUploadProgress
    }

}